import React, { useState, useEffect } from 'react';
import axios from "axios";
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import TablaComponent from './tabla';

import { Auth } from 'aws-amplify';

import {
    FormBlock,
    FormTitle,
    HalfBlock,
} from "../../../generalStyles/mixin";
import ExcelExportAsync from "../../button/ExcelExportAsync";
import * as env from "../../../environment";

const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

const { API_URL_BACKEND } = env[process.env.NODE_ENV];

function DespachoDigitalComponent() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const [periodos, setPeriodos] = useState([])
    const [periodoId, setPeriodoId] = useState(0)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        // Llamamos a la API para obtener todos los reportes existentes
        obtienePeriodos()
    }, []);

    const obtienePeriodos = async () => {

        await refreshToken();

        const config = {
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                AuditUser: `${localStorage.getItem('user')}`
            }
        };

        const endpoint = `${API_URL_BACKEND}/report/despachodigital/periodos/`

        console.log("Llamando al endpoint [" + endpoint + "] con el config [" + config + "]", config)

        setLoading(true)
        try {
            const response = await axios.get(endpoint, config)

            if (response.status === 200) {
                console.log("Respuesta", response.data)
                setPeriodos(response.data.periodos)
            } else {
                alert("error " + response.status + " : " + response.message)
            }
        } catch (e) {
            //console.log("EPA",e)
            localStorage.clear();
            window.location = '/';
        }
        setLoading(false)
    }

    const handleChange = (event) => {
        setPeriodoId(event.target.value);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const refreshToken = async () => {
        try {
            const session = await Auth.currentSession();
            console.log("session", session)
            console.log("access token", session.accessToken.jwtToken)
            localStorage.setItem("token", session.accessToken.jwtToken);
        } catch (e) {
          localStorage.clear();
          window.location = '/';
        }
      };

    return (<>
        <FormBlock>
            <FormTitle>Reportes despachos digitales</FormTitle>

            <HalfBlock>
                <FormControl className={classes.formControl}>

                    <InputLabel id="demo-controlled-open-select-label">Período</InputLabel>
                    <Select
                        labelId="demo-controlled-open-select-label"
                        id="demo-controlled-open-select"
                        open={open}
                        onClose={handleClose}
                        onOpen={handleOpen}
                        value={periodoId}
                        onChange={handleChange}
                        disabled={loading}
                    >
                        <MenuItem value="0">
                            <em>Seleccione un período</em>
                        </MenuItem>
                        {periodos.map((periodo) => (
                            <MenuItem key={periodo.id} value={periodo.id}>Periodo {periodo.anio} / {periodo.mes}</MenuItem>
                        ))}
                    </Select>
                    <div class="loader-box">
                    {loading && <div class="loader"></div>}
                    </div>
                </FormControl>
            </HalfBlock>
        </FormBlock>

        {periodoId > 0 && <>
            <br/>
            <FormBlock>
                <TablaComponent idPeriodo={periodoId} /> 
            </FormBlock>
            <br/>
            <FormBlock>
                <HalfBlock>
                    <ExcelExportAsync elPeriodo={periodoId} fileName="despachoDigital"/>
                </HalfBlock>
            </FormBlock>
        </>}
    </>
    )
}

export default DespachoDigitalComponent;